import React, { FC, InputHTMLAttributes, useState } from 'react';
import { IoEyeOff, IoEye } from 'react-icons/io5';

import Text from '../Text';

import UtilFunctions from '~utils/functions';
import * as InputStyles from './_labelledInput.module.scss';

type LabelledInputProps = InputHTMLAttributes<HTMLInputElement> & {
    label: string;
    value?: string;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    placeholder?: string;
    isRow?: boolean;
    isFilter?: boolean;
    isForm?: boolean;
    error?: string;
    className?: string;
    isPassword?: boolean;
}

const LabelledInput: FC<LabelledInputProps> = ({
    label,
    value,
    onChange,
    placeholder,
    isRow,
    isFilter,
    error,
    className,
    isPassword,
    ...otherProps
}) => {
    const inputStyles = UtilFunctions.Styles.concatClassNames([
        InputStyles.input,
        (isFilter ? InputStyles['is-filter'] : ''),
        (error ? InputStyles['is-error'] : ''),
    ]);

    const [hidePassword, setHidePassword] = useState(true);

    const toggleHidePassword = () => setHidePassword(!hidePassword);

    return (
        <div
            className={`${isRow ? InputStyles['row-container'] : InputStyles.container} ${className}`}
        >
            <div>
                <Text
                    isBold
                    label={label}
                    className={InputStyles.label}
                />

                <div className={InputStyles['input-container']}>
                    <input
                        className={inputStyles}
                        value={value}
                        onChange={onChange}
                        placeholder={placeholder}
                        type={isPassword && hidePassword ? 'password' : 'text'}
                        {...otherProps}
                    />

                    {isPassword
                    && (
                        <button
                            onClick={toggleHidePassword}
                            tabIndex={-1}
                        >
                            {hidePassword ? <IoEyeOff size={20} /> : <IoEye size={20} />}
                        </button>
                    )
                    }
                </div>
            </div>

            {error
                && (
                    <Text
                        label={error}
                        isError
                        className={InputStyles.error}
                    />
                )
            }
        </div>
    );
};

export default LabelledInput;
